// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3NuP-","footer":"ChangeClinic_footer__3JijI"};